import React from 'react';
import dictionary from './translations/dictionary.json';
import { renderToString } from 'react-dom/server';
import parse from 'html-react-parser';
import he from 'he';

let i18nSimpleResources = {};
let i18nSimpleDefaultNamespace = '';
let additionalLanguage = undefined;
let tooltipProcessedPerNamespace = {};

const excludedTranslations = [
  'sitemap',
  'docsNavContent',
  'nav',
  'mobile-nav',
  'pricingToolkit',
  'index',
  'freeEmailTools',
  'realTimeAnimation',
  'membersTranslations',
  'dmarcCheckerTool',
];

const addResources = (lang, name, res) => {
  // console.log(`TODO IB addResources lang: `, lang);
  // console.log(`TODO IB addResources name: `, name);
  // console.log(`TODO IB addResources res: `, res);
  if (!lang) {
    console.error(`i18n Invalid lang ${lang}`);
  }
  if (!name) {
    console.error(`i18n Invalid namespace ${name}`);
  }
  if (!res) {
    console.error(`i18n Invalid res ${res}`);
  }
  if (!i18nSimpleResources[lang]) {
    i18nSimpleResources[lang] = {};
  }
  if (!i18nSimpleResources[lang][name]) {
    i18nSimpleResources[lang][name] = {};
  }
  i18nSimpleResources[lang][name] = { ...i18nSimpleResources[lang][name], ...res };
};

const setDefaultNamespace = (name) => {
  // console.log(`TODO IB setDefaultNamespace name: `, name);
  i18nSimpleDefaultNamespace = name;
};

export const getCurrentISOLanguage = () => {
  if (typeof global !== 'undefined' && global.__SSR_CONTEXT_LANG__) {
    return global.__SSR_CONTEXT_LANG__;
  }

  if (typeof window === 'undefined') {
    return process.env.REACT_APP_CURRENT_BUILD ?? 'en';
  }
  return additionalLanguage ?? process.env.REACT_APP_CURRENT_BUILD ?? 'en';
};

export const t = (key, cleanString = false) => {
  const lang = getCurrentISOLanguage();
  const parts = key.split(':');
  let namespace = undefined;
  let keyWithNoNamespace = undefined;
  if (parts.length >= 2) {
    if (parts.length > 2) {
      console.error(`i18n: Error with key ${key}`);
    }
    namespace = parts[0];
    keyWithNoNamespace = parts[1];
  } else {
    namespace = i18nSimpleDefaultNamespace;
    keyWithNoNamespace = parts[0];
  }

  if (
    i18nSimpleResources === undefined ||
    i18nSimpleResources[lang] === undefined ||
    i18nSimpleResources[lang][namespace] === undefined ||
    i18nSimpleResources[lang][namespace][keyWithNoNamespace] === undefined
  ) {
    return key;
  } else {
    return typeof i18nSimpleResources[lang][namespace][keyWithNoNamespace] === 'string'
      ? parse(i18nSimpleResources[lang][namespace][keyWithNoNamespace])
      : cleanString
      ? renderToString(i18nSimpleResources[lang][namespace][keyWithNoNamespace]).replace(/<span class="tooltip">.*?<\/span>|<[^>]*>/gs, '')
      : i18nSimpleResources[lang][namespace][keyWithNoNamespace];
  }
};

export const i18nInitNamespace = (name, translations, setDefault, pageProps) => {
  // console.log(`TODO IB call i18nInitNamespace with name: ${name} setDefault: ${setDefault}`);
  // console.log(`TODO IB call i18nInitNamespace with translations`, translations);
  if (pageProps?.pageContext?.additionalLanguage) {
    additionalLanguage = pageProps?.pageContext?.additionalLanguage;
  }
  const lang = getCurrentISOLanguage();

  const res = translations[lang];
  if (!res) {
    console.error(`i18n: No translation found for ${name} in ${lang}`);
  }

  if (!tooltipProcessedPerNamespace[name] && !excludedTranslations.includes(name)) {
    const langDictionary = dictionary[lang];

    const processedTerms = new Set();
    Object.keys(res).forEach((key) => {
      res[key] = addTooltipToText(key, res[key], langDictionary, processedTerms);
    });
    tooltipProcessedPerNamespace[name] = true;
  }

  addResources(lang, name, res);
  if (setDefault) {
    setDefaultNamespace(name);
  }

  // console.log('TODO IB i18n.defaultNamespace: ', i18nSimpleDefaultNamespace);
  // console.log('TODO IB i18n.resources: ', i18nSimpleResources);
};
const addTooltipToText = (key, text, langDictionary, processedTerms) => {
  let resultText = renderToString(text);
  resultText = he.unescape(resultText);

  if (
    ![
      'question_1',
      'question_2',
      'question_3',
      'question_4',
      'question_5',
      'question_6',
      'question_7',
      'question_8',
      'question_9',
      'question_10',
      'question_11',
      'question_12',
      'question_13',
      'question_14',
      'question_schema_1',
      'question_schema_2',
      'question_schema_3',
      'question_schema_4',
      'question_schema_5',
      'answer_1',
      'answer_2',
      'answer_3',
      'answer_4',
      'answer_5',
      'answer_6',
      'answer_7',
      'answer_8',
      'answer_9',
      'answer_10',
      'answer_11',
      'answer_12',
      'answer_13',
      'answer_14',
      'answer_schema_1',
      'answer_schema_2',
      'answer_schema_3',
      'answer_schema_4',
      'answer_schema_5',
    ].includes(key)
  ) {
    Object.keys(langDictionary).forEach((term) => {
      if (!processedTerms.has(term.toLowerCase())) {
        const regex = new RegExp(`\\b(${term})(s|ing)?\\b`, 'i');
        resultText = resultText.replace(regex, (match) => {
          processedTerms.add(term.toLowerCase());
          const tooltipRegex = /<span[^>]*class="tooltip"/;
          if (tooltipRegex.test(resultText)) {
            return match;
          }

          const spaceIndex = match.indexOf(' ');

          const closingAnchorTagIndex = match.indexOf('</a>');
          const hasClosingAnchor = closingAnchorTagIndex !== -1;

          const getWordWithSuffix = (word, afterSpace) => {
            if (afterSpace.startsWith('s</a>')) {
              return word + 's';
            } else if (afterSpace.startsWith('ing</a>')) {
              return word + 'ing';
            }
            return word;
          };

          // If there is a space, handle both space and `</a>`
          if (spaceIndex !== -1) {
            const beforeSpace = match.slice(0, spaceIndex);
            const afterSpace = match.slice(spaceIndex);

            if (hasClosingAnchor) {
              // Handle the case where the word is followed by a `</a>` and possibly suffixes
              const suffixModifiedWord = getWordWithSuffix(beforeSpace, afterSpace);
              const beforeAnchor = afterSpace.slice(0, closingAnchorTagIndex + 4);
              const afterAnchor = afterSpace.slice(closingAnchorTagIndex + 4);

              return `<span style="margin: 0; padding: 0;">${suffixModifiedWord}${beforeAnchor}</span><span class="tooltip"><i class="icon-info" style='font-size: 10px; vertical-align: super; margin-left: 2px; font-style: normal;'>&#9432;</i><em class="tooltip__text definitions__tooltip" style='line-height: 1.4; font-size: 12px; white-space: normal; font-style: normal'>${langDictionary[term]}</em></span>${afterAnchor}`;
            } else {
              // Regular case with no `</a>`
              return `<span style="margin: 0; padding: 0;">${beforeSpace}${afterSpace}<span class="tooltip"><i class="icon-info" style='font-size: 10px; vertical-align: super; margin-left: 2px; font-style: normal;'>&#9432;</i><em class="tooltip__text definitions__tooltip" style='line-height: 1.4; font-size: 12px; white-space: normal; font-style: normal'>${langDictionary[term]}</em></span></span>`;
            }
          } else {
            // No space, handle `</a>` case after the word directly
            if (hasClosingAnchor) {
              const suffixModifiedWord = getWordWithSuffix(match.slice(0, closingAnchorTagIndex), match.slice(closingAnchorTagIndex));
              const beforeAnchor = match.slice(0, closingAnchorTagIndex + 4);
              const afterAnchor = match.slice(closingAnchorTagIndex + 4);

              return `<span style="margin: 0; padding: 0;">${suffixModifiedWord}${beforeAnchor}</span><span class="tooltip"><i class="icon-info" style='font-size: 10px; vertical-align: super; margin-left: 2px; font-style: normal;'>&#9432;</i><em class="tooltip__text definitions__tooltip" style='line-height: 1.4; font-size: 12px; white-space: normal; font-style: normal'>${langDictionary[term]}</em></span>${afterAnchor}`;
            } else {
              // Regular case without `</a>`
              return `<span style="margin: 0; padding: 0;">${match}<span class="tooltip"><i class="icon-info" style='font-size: 10px; vertical-align: super; margin-left: 2px; font-style: normal;'>&#9432;</i><em class="tooltip__text definitions__tooltip" style='line-height: 1.4; font-size: 12px; white-space: normal; font-style: normal'>${langDictionary[term]}</em></span></span>`;
            }
          }
        });
      }
    });
  }

  return parse(resultText);
};
